import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { Appointment } from "@comunicare/comunicare-interfaces";
import * as moment from "moment";
import { BehaviorSubject } from "rxjs";

export class TeleconsultationListDataSource extends MatTableDataSourceExtended<Appointment> {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  sortingDataAccessor = (data: Appointment, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "start":
        return moment(data.start).unix();
      default:
        return "";
    }
  };

  constructor() {
    super();
  }

  public loadData(appointments: Appointment[]): void {
    this.data = appointments;
  }
}
